
import { AddressWizardTypes } from "../AddressWizard/AddressWizardTypes";
import { VAM2types } from "./VAMv2Types";



enum OMclassnames {

    "orchestra_employment" = "orchestra_employment",
    "vt_duty_type" = "vt_duty_type",
    "present_type" = "present_type",
    "absenteeism_type" = "absenteeism_type",
    "functional_group" = "functional_group",
    "functional_sub_group" = "functional_sub_group",
    "functional_main_group" = "functional_main_group",
    "musican_contract_md" = "musican_contract_md",
    "musican_planning_ev_project" = "musican_planning_ev_project",
    "musican_planning_ev_project_status" = "musican_planning_ev_project_status"
}


enum OMselectEntityDialogModes {
    musician = "selectMusician"
}


export {
  
    OMclassnames,
    type OMtypes,
    OMselectEntityDialogModes,
}

/* diverse wiederkehrende Typisierungen */
namespace OMtypes {

    //export enum CheckinAvailabilityIconMap {
    //    "unavailable" = "fas fa-ban w3-opacity w3-large",
    //    "future" = "fas fa-circle w3-large",
    //    "past_checked" = "far fa-check-circle w3-text-green w3-opacity w3-large",
    //    "past_unchecked" = "far fa-times-circle w3-text-red w3-opacity w3-large",
    //    "available" = "far fa-circle w3-text-green w3-large",
    //    "checked" = "fas fa-check-circle w3-text-green w3-large",

    //} // ersetzt durch translations!

    export type CheckinStatus = "present" | "absent";
    export type CheckinAvailability = "unavailable" | "past_checked" | "past_unchecked" | "available" | "checked" | "future";

    
    export interface orchestraEmploymentWithCheckin extends orchestraEmployment {
        presence_confirmation_status: CheckinStatus;
        tmp_presence_confirmation_availability: CheckinAvailability;
       
    }


    export interface orchestraEmployment extends more.EntityAPIResult{
        date_start: Date,
        date_end: Date,
        gDisp_1?: string,
       employment_value_actual: number;
       ref_associate: AddressWizardTypes.AssociateEntity;
       ref_vt_duty_type: dutyType;
       ref_ev_booking: VAM2types.EvBooking_Base;
       ref_functional_group: functionalGroup;
       ref_functional_sub_group: functionalSubGroup;
    }


    export interface EvBookingWithEmployments extends VAM2types.EvBooking_Base {
        EL_vt_employment_ev_booking: Array<orchestraEmployment>;
    }

    export interface dutyType extends more.EntityAPIResultExtended {
        code: string;
        order: string;
        description: string;
        coloration: more.EntityAPIColor;
        EL_vt_internal_employment_vt_duty_type?: Array<orchestraEmployment>;
    }

    export interface dutyTypePresent extends dutyType {
        percentage_present: number;
    }

    export interface dutyTypeAbsend extends dutyType {
        percentage_free: number;
    }
   
    interface functionalMainGroup extends more.EntityAPIResult {
        code: string;
        order: string;
        description: string;
        coloration: more.EntityAPIColor;
    }
    export interface functionalGroup extends more.EntityAPIResult{
        code: string;
        order: string;
        description: string;
        coloration: more.EntityAPIColor;
        ref_voice_attributelist: voiceAttributelist;
        ref_functional_main_group: functionalMainGroup;

    }

    export interface functionalSubGroup extends more.EntityAPIResult{
        ref_functional_group: functionalGroup,
        code: string;
        order: string;
        description?: string;
        coloration?: more.EntityAPIColor;
        description_short?: string;
        duty_quota_per_year?: number;
        day_quota_per_year?: number;
    }


    export interface voiceAttributelist extends more.EntityAPIResult {
        number: number,
        attribute_instrumentation_group_number: string,
        attribute_instrumentation_group_comment: string,
        attribute_name_max_cast_plan: string,
        attribute_name_plan_casted: string,
        attribute_name_max_cast_act: string,
        attribute_name_actual_casted: string,
        attribute_instrumentation_group_number_diff: string
    }

    export interface plannedMusician extends more.EntityAPIResult {
        c_associate: string;
        ref_associate: AddressWizardTypes.AssociateEntity;
        ref_functional_group: functionalGroup;
        ref_functional_sub_group: functionalSubGroup;
        ref_musican_planning_ev_project_status: plannedMusicianStatus;
        ref_engagement: musicianEngagementEvProfession;
        is_substitute: boolean;
        note: string;
    }

    export interface plannedMusicianStatus extends more.EntityAPIResult {
        code: string;
        order: string;
        description: string;
        coloration: more.EntityAPIColor;
    }

    export interface musicianContract extends more.EntityAPIResult {
        ref_associate: AddressWizardTypes.AssociateEntity;
        ref_musican_contract_type: musicianContractType;
        ref_musican_contract_md_status: musicianContractStatus;
        note: boolean;
        date_valid_from: Date;
        date_valid_until: Date;
        is_active: boolean;
        is_dummy: boolean;
        EL_contract_data_element_orch_musican_contract_md: Array<musicianContractElement>
        EL_engagement_ev_profession_musican_contract_md: Array<musicianEngagementEvProfession>
    }

    interface musicianContractType extends more.EntityAPIResult {
        description: string;
        code: string;
        note: string;
        coloration: more.EntityAPIColor;
        order: number;
        is_substitute: boolean;
        is_relevant_for_employmentvalue: boolean;
        is_compulsor_service_rate_needed: boolean;
        
    }

    interface musicianContractStatus extends more.EntityAPIResult {
        description: string;
        code: string;
        coloration: more.EntityAPIColor;
        order: number;
    }

    export interface musicianContractElement extends more.EntityAPIResult {
        date_valid_from?: Date;
        date_valid_until?: Date;
        compulsor_service_rate: number;
        ref_functional_sub_group: functionalSubGroup;
    }

    export interface musicianEngagementEvProfession extends more.EntityAPIResult {
        ref_musican_contract_md: musicianContract;
        ref_ev_profession: VAM2types.EvProfession;
    }

    export interface musicianEngagementFunctionGroup extends more.EntityAPIResult {
        ref_musican_contract_md: musicianContract;
        ref_functional_sub_group: functionalSubGroup;
    }
}